// extracted by mini-css-extract-plugin
export var subtitle = "_ay-2";
export var title = "_ay-0";
export var titleNoWrap = "_ay-1";